// extracted by mini-css-extract-plugin
export default {"title":"Products_title__6xU8g","titleContainer":"Products_titleContainer__M1ZjJ","gridContainer":"Products_gridContainer__Qtmtx"};